import { Typography as MuiTypography } from "@mui/material";
import { ParsedValue } from "../TextWithValue";
import { cn } from "@/src/shared/utils/mergeTwClasses";

export function Title(props: any) {
  const { type, text, displayName, size, className, lineHeight, ...rest } =
    props;
  return (
    <MuiTypography
      gutterBottom
      variant={size}
      style={{
        ...rest,
        justifyContent: rest.textAlign,
        background: rest.background || "#000",
        lineHeight: lineHeight ? lineHeight + "px" : "",
      }}
      className={cn("w-fit gradient-text", className)}
    >
      <ParsedValue value={text} />
    </MuiTypography>
  );
}
